import Vue from 'vue';
import Router from 'vue-router';
import home from '@/components/home/index';
import details from '@/components/game-details/index';
import error from '@/components/error';
import maintenance from '@/components/maintenance';
import termsOfUse from '@/components/legal/tou/termsOfUse';
import privacyPolicy from '@/components/legal/pp/privacyPolicy';
import termsOfSale from '@/components/legal/terms-of-sale';
import launcherDownload from '@/components/launcher-download';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/main/',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/:locale/',
			name: 'main',
			component: home,
			props: true,
		},
		{
			path: '/:locale/:title/details',
			name: 'details',
			component: details,
			props: true,
		},
		{
			path: '/:locale/maintenance',
			name: 'maintenance',
			component: maintenance,
			props: true,
		},
		{
			path: '/:locale/legal/tou',
			name: 'termsOfUse',
			component: termsOfUse,
			props: true,
		},
		{
			path: '/:locale/legal/privacy',
			name: 'privacyPolicy',
			component: privacyPolicy,
			props: true,
		},
		{
			path: '/:locale/legal/terms-of-sale',
			name: 'termsOfSale',
			component: termsOfSale,
			props: true,
		},
		{
			path: '/:locale/download/launcher',
			name: 'launcherDownload',
			component: launcherDownload,
			props: true,
		},
		{
			path: '/:locale/corporate/about-nexon',
			name: 'aboutNexon',
			component: () => import(/* webpackChunkName: "about-nexon" */ '@/components/corporate/about'),
			props: true,
		},
		{
			path: '/:locale/corporate/careers',
			name: 'careers',
			component: () => import(/* webpackChunkName: "careers" */ '@/components/corporate/careers'),
			props: true,
		},
		{
			path: '/:locale/corporate/press-releases',
			name: 'pressReleases',
			component: () => import(/* webpackChunkName: "press-releases" */ '@/components/corporate/press-releases'),
		},
		{
			path: '/:locale/corporate/press-releases/article-:articleId',
			name: 'pressReleasesArticle',
			component: () => import(/* webpackChunkName: "press-releases" */ '@/components/corporate/press-releases/article'),
		},
		{
			path: '*',
			name: 'error-redirect',
			redirect: () => {
				const pathLang = location.pathname.split('/')[2],
					cookieLang = Vue.cookie.get('i18next') || 'en';
				if (pathLang.length !== 2) {
					return {
						path: `/${cookieLang}/error`,
					};
				}
				Vue.cookie.set('i18next', pathLang);
				return {
					path: `/${pathLang}/error`,
				};
			},
		},
		{
			path: '/:locale/error',
			name: 'error',
			component: error,
			props: true,
		},
		{
			path: '/:locale/:title',
			redirect: (to) => {
				return {
					name: 'details',
					params: {
						locale: to.params.locale,
						title: to.params.title,
					},
				};
			},
			props: true,
		},
	],
});

router.beforeEach((to, from, next) => {
	const routeLang = to.params.locale || 'en',
		cookieLang = Vue.cookie.get('i18next');
	if (!cookieLang) {
		Vue.cookie.set('i18next', routeLang);
	}
	// <html lang="{routeLang}">
	document.getElementsByTagName('html')[0].lang = routeLang;
	document.body.className = to.name.toLowerCase();
	next();
});

export default router;
